export default {
    singapore: '新加坡',
    thailand: '泰国',
    malaysia: '马来西亚',
    education_calculator: '教育计算器',
    see_how_much: '看看孩子的教育可以花费多少 {entity} 和国外，以及如何资助他们',
    financing_for_education:
        '为教育筹资可能很困难，需要仔细规划。让我们看看我们可以做些什么来使您更易于管理。',
    next: '下一个',
    back: '后退',
    your_childs_profile: '您孩子的个人资料',
    let_me_help: '让我来帮助你',
    estimations_only: '*仅估算，请咨询您信任的财务顾问以获取更多信息',
    grow_your_education_savings: '通过选择合适的金融产品，更多地增加您的教育储蓄',
    each_year: '% 每年',
    assuming_your_money: '假设你的钱会增长',
    year: '年*',
    base_your_goal: '基于您的目标 ',
    education_cost_brief:
        '费用包括学费和生活费（有关这些数字的获得位置，请参阅可用的 <i> <a href="https://support.goalsmapper.com/hc/en-us/articles/900004799406-How-is-the-data-for-the-Education-Planner-widget-collected-" rel="noopener noreferrer" target="_blank"> 参考</a></i>.)',
    where_to_study: '你想让他们去哪里学习？',
    education_study_destination: '学习目的地',
    field_of_study: '学年',
    year_of_study: '学年',
    year_singular: '年',
    years_to_enrolment: '入学年限',
    age: '年龄',
    foreigner: '外国人',
    citizen_pr: '公民/永久居民',
    what_residency_status: '你的居留身份是什么？',
    child_field_of_study: '您孩子的学习领域',
    university_age: '进入大学的年龄',
    childs_age: '孩子的年龄',
    start_telling: '首先告诉我们您孩子的个人资料',
    set_aside: '你必须搁置 ',
    profile: '轮廓',
    plan: '计划',
    total_cost_includes: '总费用包括',
    ok: '好的',
    annual_cost_from: '年费用从 ',
    today: '今天',
    select: '选择',
    death: '死亡',
    critical_illness: '严重的疾病',
    disability_tpd: '失能 (TPD)',
    insurance_coverage_brief: '告诉我们您目前的保险范围',
    profile_brief: '首先告诉我们您的个人资料',
    these_information: '这些信息有助于我们了解您的保险需求的基础。',
    your_age: '你的年龄',
    your_gender: '您的性别',
    your_life_expectancy: '你的预期寿命',
    insurance_estimation:
        '*基于数据的估计 <a target="_blank" rel="noopener noreferrer" href="https://www.worldometers.info/demographics/life-expectancy/">Worldometers.info</a>',
    your_monthly_expense: '您每月的开支',
    mandatory_field: '" (必填项)"',
    see_below: '请参阅下文了解您的承保范围摘要*',
    increase_your_coverage: '继续了解如何增加覆盖范围',
    estimation_only: '*仅估算，请咨询您信任的财务顾问以获取更多信息',
    exisiting_coverage: '现有覆盖范围',
    coverage_needed: '需要覆盖',
    coverage_gap: '覆盖差距（短缺）',
    years: '年',
    what_if: '如果...',
    what_if_one: '如果...1',
    what_if_two: '如果...2',
    questions_below:
        '下面的一些问题是高度“如果”。如果您在回答问题时遇到困难，请尝试给出粗略的估计或假设。',
    ci_event: '如果发生重大疾病，您希望得到多少年的保障？',
    disability_event: '在残疾的情况下，您希望获得多少年的补助？',
    passing_on: '万一传…',
    provide_your_family: '你想为你的家人提供多少？',
    month: '月',
    your_insurance: '您的保险',
    planning_your_protection:
        '规划您的保护需求可能很困难，需要仔细规划。让我们看看我们可以做些什么来使您更易于管理。',
    find_out_insurance: '了解您现有的保险范围是否足以满足您的需求',
    based_on_your: '根据您的输入，您 ',
    you_should_retire_by: '根据您的投入，您应该能够在 ',
    your_monthly_income: '你的月收入',
    your_profile: '你的个人资料',
    expect_to_live: '期待活到',
    monthly_income: '月收入',
    monthly_expense: '每月开支',
    percent_each_year: '% 每年.',
    adjust_growth_rate: '调整您的储蓄增长率，看看它对您的退休年龄有何影响。',
    let_me_show: '让我向您展示如何使您期望的退休年龄成为现实。',
    retirement_planner: '退休规划师',
    find_out_how_old: '了解您今天可以从储蓄和消费模式中退休多少岁”',
    gender_required: '性别是必填字段',
    age_required: '年龄是必填字段',
    life_required: '预期寿命是必填字段',
    life_expectancy: '每月费用是必填字段',
    expense_required: '每月费用是必填字段',
    required_field: '必填项目',
    field: '场地',
    positive_number: '必须是正数',
    million: '百万',
    shortfall: '短缺',
    coverage: '覆盖面',
    please_check: '请选中此框以继续',
    checked: '检查',
    cannot_exceed: '消息不能超过 500 个字符。',
    phone_required: '电话号码是必填字段',
    name_required: '名称是必填字段',
    get_in_touch: '保持联系',
    your_name: '你的名字',
    your_mobile: '您的手机',
    message: '信息',
    success: '成功！',
    in_touch_soon: '我会尽快与您取得联系。您现在可以关闭此页面并返回我的网站以获取更多信息。',
    contact_disclaimer: `<div>我同意通过以下方式收集、使用和披露我的个人数据
							{AGENT_NAME} 用于以下目的
							<br />
							a. 在我们的过程中或与我们有关的履行义务
							提供您要求的商品和/或服务；
							<br />
							b. 向您发送有关我们商品或服务的营销信息
							包括通知您我们的营销活动、计划和
							促销、幸运抽奖、会员和奖励计划等
							促销活动；
							<br />
							c. 遵守任何适用的法律、法规、守则
							实践、指导方针或规则，或协助执法和
							任何政府和/或监管机构进行的调查
							权威;
							<br />
							d. 您提供信息的任何其他目的；
							<br />
							如果您同意出于上述目的与我们联系，请继续。</div>`,
    income_required: '月收入是必填字段',
    unable_retire: '无法退休。',
    study_required: '研究领域是必填领域',
    university_age_required: '进入大学的年龄是必填字段。',
    study_country: '留学国家',
    living_expenses: '生活开销',
    food: '食物',
    transport: '运输',
    books: '图书',
    accommodation: '住所',
    personal_expenses: '个人支出',
    all_citizenship: '所有公民',
    pr: '永久居民',
    international: '国际的',
    singaporean: '只有新加坡人',
    tuition_fee: '学费',
    total_per_year: '总计（每年）',
    accountancy: '会计',
    architecture: '建筑学',
    arts: '艺术',
    arts_science: '艺术/科学',
    business: '商业',
    computing: '计算',
    engineering: '工程',
    law: '法律',
    medicine: '药物',
    music: '音乐',
    science: '科学',
    aus: '澳大利亚',
    my: '马来西亚',
    uk: '英国',
    us: '美国',
    sg: '新加坡',
    th: '泰国',
    id: '印度尼西亚',
    THB: 'THB',
    for_how_long: '多长时间?',
    private: '私人'
};
